const createPermissionIndexTransformer = (data) => {
  return {
    permission_index: data.permission_index,
  };
};

export { createPermissionIndexTransformer };
